<template>
<div>
    <section>
        <b-field position="is-right">
            <b-input placeholder="Search..." type="search" icon="search" v-model="search">
            </b-input>
            <p class="control">
                <b-dropdown class="hover-rotate-90" hoverable aria-role="list" position="is-bottom-left" :disabled="toggleDelete">
                    <button class="button is-primary" slot="trigger">
                        <b-icon icon="plus" pack="fal"></b-icon>
                    </button>

                    <b-dropdown-item v-for="type in transferTypes" aria-role="listitem" @click="addTransfer({name:type.default,type:type.name},true)" :title="type.title">
                        <span v-if="!type.icons">
                            <b-icon :icon="icon(type.name)" pack="fad"></b-icon> {{type.title}}
                        </span>
                        <span v-else>
                            <b-icon v-for="ico in type.icons" :icon="ico" pack="fad"></b-icon>
                        </span>
                    </b-dropdown-item>
                </b-dropdown>
            </p>
            <p class="control">
                <button class="button is-danger" @click="toggleDelete = !toggleDelete">
                    <b-icon icon="minus" pack="fal"></b-icon>
                </button>
            </p>
        </b-field>

    </section>
    <section>
        <Draggable :list="$root.event.transfers" group="transfers" :options="{handle:'.draggy'}">
            <div class="arrangement-cards">
                <div class="card is-grid" v-for="transfer in filtered" :class="{ giggly: toggleDelete }">
                    <header class="card-header">
                        <p class="card-header-title">
                            <b-icon v-if="!toggleDelete" :icon="icon(transfer.type)" pack="fad" :class="{ draggy: toggleDrag }" class="icon-fix"></b-icon>
                            <a v-else @click="removeTransfer(transfer)">
                                <b-icon icon="minus-circle" pack="fas" type="is-danger"></b-icon>
                            </a>
                            <span>{{transfer.name}}</span>
                        </p>
                    </header>
                    <div class="card-content">
                        <div class="content">
                            <b-icon icon="sign-out-alt" pack="fad"></b-icon>&nbsp;&nbsp;<span v-if="transfer.start">{{transferLocation(transfer.start,transfer.type,'from')}}</span>
                            <br>
                            <b-icon icon="sign-in-alt" pack="fad"></b-icon>&nbsp;&nbsp;<span v-if="transfer.destination">{{transferLocation(transfer.destination,transfer.type,'to')}}</span>
                            <br>
                            <b-icon icon="calendar-alt" pack="fad"></b-icon>&nbsp;&nbsp;<span v-if="transfer.date">{{$moment(transfer.date, 'YYYY-MM-DD').format('dddd, D. MMM YY')}}</span>
                            <br>
                            <b-icon icon="clock" pack="fad"></b-icon>&nbsp;&nbsp;<span v-if="transfer.begin && transfer.end">{{transfer.begin}} - {{transfer.end}}</span>
                        </div>
                    </div>
                    <footer class="card-footer">
                        <a class="card-footer-item" @click="editTransfer(transfer)">
                            <b-icon pack="fad" icon="edit" size="is-small"></b-icon>
                        </a>
                        <a class="card-footer-item" @click="addTransfer(transfer)" title="Duplizieren">
                            <b-icon pack="fad" icon="clone" size="is-small"></b-icon>
                        </a>

                    </footer>
                </div>
            </div>

        </Draggable>
    </section>
    <b-modal :active.sync="isCardModalActive" scroll="keep" @close="saveTransfer()">
        <div class="card is-modal">
            <header class="card-header">
                <p class="card-header-title">
                    <b-icon :icon="icon(editableTransfer.type)" pack="fad"></b-icon>&nbsp;&nbsp;{{editableTransfer.name}}
                </p>
            </header>
            <div class="card-content">

                <div class="content">
                    <b-field horizontal label="Name"  class="field-grid">
                        <b-input v-model="editableTransfer.name"></b-input>
                        <b-select v-model="editableTransfer.type" placeholder="Bitte wählen Sie den Typ:" :icon="icon(editableTransfer.type)" @input="resetTransfer()">
                            <option v-for="type in transferTypes" :value="type.name">
                                {{type.title}}
                            </option>
                        </b-select>
                    </b-field>
                    <b-field horizontal label="Abfahrt" class="field-grid">
                        <b-select v-if="editableTransfer.type == 'eventAcc' || editableTransfer.type == 'eventEvent'" v-model="editableTransfer.start" placeholder="Bitte wählen Sie eine Location">
                            <option v-for="(location, key) in $root.event.locations" :value="location.id">
                                {{location.name}}
                            </option>
                        </b-select>
                        <b-select v-else-if="editableTransfer.type == 'accEvent'" v-model="editableTransfer.start" placeholder="Bitte wählen Sie eine Unterbringung">
                            <option v-for="(location, key) in $root.event.accommodations" :value="location.id">
                                {{location.name}}
                            </option>
                        </b-select>
                        <b-input v-else v-model="editableTransfer.start" expanded></b-input>
                        <Timepicker placeholder="Bitte Auswählen..." v-model="editableTransfer.begin" :inline="false">
                        </Timepicker>
                    </b-field>
                    <b-field horizontal label="Ankunft" class="field-grid">
                        <b-select v-if="editableTransfer.type == 'accEvent' || editableTransfer.type == 'eventEvent'" v-model="editableTransfer.destination" placeholder="Bitte wählen Sie eine Location">
                            <option v-for="(location, key) in $root.event.locations" :value="location.id">
                                {{location.name}}
                            </option>
                        </b-select>
                        <b-select v-else-if="editableTransfer.type == 'eventAcc'" v-model="editableTransfer.destination" placeholder="Bitte wählen Sie eine Unterbringung">
                            <option v-for="(location, key) in $root.event.accommodations" :value="location.id">
                                {{location.name}}
                            </option>
                        </b-select>
                        <b-input v-else v-model="editableTransfer.destination" expanded></b-input>
                        <Timepicker placeholder="Bitte Auswählen..." v-model="editableTransfer.end" :inline="false">
                        </Timepicker>
                    </b-field>
                    <b-field label="Gruppe" horizontal class="field-grid">
                        <b-select v-if="!tempGroup.active" v-model="editableTransfer.group" expanded>
                            <option value="0" key="0">
                                keine Gruppe
                            </option>
                            <option v-for="option in $root.event.groups" :value="option.id" :key="option.id">
                                {{ option.name }}
                            </option>
                        </b-select>
                        <b-input v-else v-model="tempGroup.name" expanded></b-input>
                        <p class="control">
                            <button v-if="tempGroup.active" class="button is-success" @click="newGroup()">
                                <b-icon icon="save" pack="fad"></b-icon>
                            </button>
                            <button v-else class="button is-primary" @click="tempGroup.active = true">
                                <b-icon icon="plus" pack="fal"></b-icon>
                            </button>
                        </p>
                    </b-field>
                    <b-field label="Beschreibung" horizontal>
                        <b-input maxlength="2000" v-model="editableTransfer.description" type="textarea"></b-input>
                    </b-field>
                    <b-field horizontal label="Datum">
                        <Datepicker :inline="false" v-model="editableTransfer.date" :min="$root.event.start" :max="$root.event.end" placeholder="Bitte auswählen..." icon="calendar-day" pack="fad">
                        </Datepicker>
                    </b-field>
                    <b-button type="is-success" @click="saveTransfer()">Speichern</b-button>
                </div>
            </div>
        </div>
    </b-modal>
</div>
</template>

<script>
export default {
    name: 'Transfers',
    components: {

    },
    props: {

    },
    data() {
        return {
            toggleDelete: false,
            toggleDrag: true,
            search: '',
            tempGroup: {
                active: false,
                name: '',
            },
            isCardModalActive: false,
            editableTransfer: {},
            transferTypes: [{
                title: 'Transfer',
                icon: 'route',
                name: 'main',
                default: 'neuer Transfer'
            }, {
                title: 'Unterkunft nach Event',
                icon: 'bus-alt',
                name: 'accEvent',
                default: 'neuer Transfer',
                icons: [
                    'bed',
                    'angle-right',
                    'users-class'
                ]
            }, {
                title: 'zwischen Events',
                icon: 'bus-alt',
                name: 'eventEvent',
                default: 'neuer Transfer',
                icons: [
                    'users-class',
                    'angle-right',
                    'users-class'
                ]
            }, {
                title: 'Event nach Unterkunft',
                icon: 'bus-alt',
                name: 'eventAcc',
                default: 'neuer Transfer',
                icons: [
                    'users-class',
                    'angle-right',
                    'bed'
                ]
            }]
        }
    },
    methods: {
        update(id = this.$route.params.id) {
            return true
        },
        saveEvent() {
            this.$root.saveEvent(this.$route.params.id)
        },
        newGroup() {
            let group = {}
            group.id = ++this.$root.event.counter.groups
            group.name = this.tempGroup.name
            if(typeof this.$root.event.groups != 'array' && typeof this.$root.event.groups != 'object') this.$root.event.groups = []
            this.$root.event.groups.push(group)
            if(this.editableTransfer) {
                this.editableTransfer.group = group.id
            }
            this.tempGroup.name = ''
            this.tempGroup.active = false
            this.saveEvent()
        },
        addTransfer(template = {}, init = false) {
            let transfer = {}
            transfer = Object.assign(transfer, template)
            transfer.id = ++this.$root.event.counter.transfers
            if (!transfer.name) {
                transfer.name = 'Neuer Transfer'
            } else if (!init) {
                transfer.name += ' Kopie'
            }
            if (!transfer.type) {
                transfer.type = 'misc'
            }
            if (!transfer.group) {
                transfer.group = 0
            }
            this.$root.event.transfers.push(transfer)
            this.saveEvent()
        },
        editTransfer(transfer) {
            this.isCardModalActive = true
            this.editableTransfer = transfer

        },
        saveTransfer() {
            this.isCardModalActive = false
            this.$root.saveEvent(this.$route.params.id, true)
        },
        icon(type = 'main') {
            let find = this.transferTypes.find(function (element) {
                return element.name == type
            })
            return find.icon
        },
        transferLocation(loc = '', type = 'main', direction = 'from') {
            let place = loc
            let found
            if (((type == 'eventEvent' || type == 'eventAcc') && direction == 'from') || ((type == 'eventEvent' || type == 'accEvent') && direction == 'to')) {
                found = this.$root.event.locations.find(function (element) {
                    return element.id == loc
                })
                if (typeof found == 'object') {
                    place = found.name
                }
            }
            if (((type == 'eventAcc') && direction == 'to') || ((type == 'accEvent') && direction == 'from')) {
                found = this.$root.event.accommodations.find(function (element) {
                    return element.id == loc
                })
                if (typeof found == 'object') {
                    place = found.name
                }
            }
            return place
        },
        resetTransfer() {
            this.editableTransfer.start = ''
            this.editableTransfer.destination = ''
        },
        removeTransfer(old) {
            this.$buefy.dialog.confirm({
                title: 'Transfer löschen?',
                message: 'Sind Sie sicher, dass Sie den <br>Transfer <b><i>' + old.name + '</i> löschen</b> möchten?<br>Diese Aktion kann nicht Rückgängig gemacht werden.',
                confirmText: 'Transfer löschen',
                type: 'is-danger',
                hasIcon: true,
                onConfirm: () => {
                    let wksps = []
                    this.$root.event.transfers.forEach(function (element) {
                        if(element.id !== old.id){
                            wksps.push(element)
                        }
                    });
                    this.$root.event.transfers = wksps
                    this.saveEvent()
                    this.$buefy.toast.open({
                        message: 'Der Transfer <b>' + old.name + '</b> wurde gelöscht',
                        type: 'is-success'
                    })
                }
            })
        }
    },
    created() {
        // fetch the data when the view is created and the data is
        // already being observed

        this.update()
    },
    computed: {
        filtered() {
            let origin = this.$root.event.transfers,
                filtered = [],
                patt = new RegExp(this.search, "i");
            this.toggleDrag = true
            if (this.search == '') {
                return origin
            }
            if (this.search.length < 3) {
                return origin
            }
            this.toggleDrag = false
            origin.forEach(entry => {
                if (patt.test(entry.name)) {
                    filtered.push(entry)
                    return
                }
                if (patt.test(entry.description)) {
                    filtered.push(entry)
                    return
                }
                if (patt.test(entry.location)) {
                    filtered.push(entry)
                    return
                }
            })
            return filtered
        }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.c-preview {
    width: 50px;
}

.hover-rotate-90 .dropdown-trigger .icon i {
    transition: transform .8s ease;
}

.hover-rotate-90.is-active .dropdown-trigger .icon i,
.hover-rotate-90:hover .dropdown-trigger .icon i {
    transform: rotate(90deg);
}

.card.is-grid {
    display: inline-block;
    width: 250px;
    margin: 20px;
    vertical-align: top;
}

.card.is-modal {
    min-width: 270px;
    margin: 20px;
}

.event-list {
    text-align: center;
}

.giggly {
    transition: transform .05s ease;
    animation-name: giggle;
    animation-duration: .2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes giggle {
    0% {
        transform: rotate(0deg);
    }

    25% {
        transform: rotate(-1deg);
    }

    50% {
        transform: rotate(0deg);
    }

    75% {
        transform: rotate(1deg);
    }

    1000% {
        transform: rotate(0deg);
    }
}
</style>
